import React, { useEffect, useState } from "react";
import { Container, Form, Row, Col, Button, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { formatDate } from "../../../Utils/DateUtlis";
import SideMenu from "../../../Components/SideDrawer";
import PageHeader from "../../../Components/Header";
import { companyGet, employeeAdvanceGetbyCompany } from "../../../Api/Admin/AdminApi";
import { extractErrorMessage } from "../../../Utils/ErrorUtlis";

const Advance = () => {
  const [apiData, setApiData] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [loadingCompany, setLoadingComapany] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({
    company_id: null,
    advance_month: ''
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const data = await companyGet();
        if (data) {
          const companies = data.map(i => ({
            id: i._id,
            name: i.name,
            description: i.description,
            status: i.status
          }));
          setOrganizations(companies);
          setLoadingComapany(false)
          console.log(`API Data ${JSON.stringify(organizations)}`);  // Under Production         
        } else {
          console.log('No Organization data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }
    fetchCompany();
  }, [])

  const handleButton = () => {
    navigate('/addAdvance')
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const responseData = await employeeAdvanceGetbyCompany(formData);
      console.log('Response Data: ', JSON.stringify(responseData));

      if (responseData && responseData.results) {
        console.log(`Inside If results`);
        const advances = responseData.results.map(i => ({
          emp_id: i.emp_id,
          NAME: i.NAME,
          Design: i.Design,
          advance_date: formatDate(i.advance_date),
          advance_amount: i.advance_amount,
        }));
        console.log(JSON.stringify(advances));

        setApiData(advances);
        setIsLoading(false);
      } else {
        alert('No Data Received')
      }
    } catch (err) {
      setIsLoading(true);
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
  }

  return (
    <div>
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader title='Advance' showButtons={true} />
        <h4 className="mb-4 d-flex justify-content-between align-items-center">
          Advance Details
          <div className="d-flex flex-column align-items-end">
            <Button variant="primary" className="d-flex align-items-center mb-2" onClick={handleButton}>
              Add Advance
            </Button>
          </div>
        </h4>
        <Form onSubmit={handleSubmit} className="mt-4 align-items-center">
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="company_id">
              <Form.Label>Organization Name</Form.Label>
              <Form.Select
                name="company_id"
                value={formData.company_id}
                onChange={handleChange}
                required
              >
                <option value="">Select Organization</option>
                {loadingCompany ? (<div>Loading...</div>) : (organizations.map(org => (
                  <option key={org.id} value={org.id}>{org.name}</option>
                )))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md='4' controlId="advance_month">
              <Form.Label>Select Month</Form.Label>
              <Form.Control
                type="month"
                name="advance_month"
                value={formData.advance_month}
                onChange={handleChange}
                required
                style={{height:'30px'}}
              >
              </Form.Control>
            </Form.Group>
            <Form.Group as={Col} md='4'>
              <Button type="submit" variant="primary" className="d-flex align-items-center mb-2" style={{ marginTop: '25px',height:'30px' }}> 
                {/* Button Changes */}
                Advance
              </Button>
            </Form.Group>
          </Row>
        </Form>
        {isLoading ? <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div role="status">
            <span className="sr-only">No Data to Show</span>
          </div>
        </div> : <div style={{ overflow: 'auto' }}>
          <Table striped hover responsive='sm' size="sm">
            <thead>
              <tr>
                <th className="fs-12">Employee Id</th>
                <th className="fs-12">Employee Name</th>
                <th className="fs-12">Desigination</th>
                <th className="fs-12">Advance Date</th>
                <th className="fs-12">Advance Amount</th>
              </tr>
            </thead>
            <tbody>
              {apiData.map((emp, i) => (
                <tr key={emp.emp_id}>
                  <td className="fs-12">
                    {emp.emp_id}
                  </td>
                  <td className="fs-12">
                    {emp.NAME}
                  </td>
                  <td className="fs-12">
                    {emp.Design}
                  </td>
                  <td className="fs-12">
                    {emp.advance_date}
                  </td>
                  <td className="fs-12">
                    {emp.advance_amount}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>}
      </Container>
    </div>
  );

}

export default Advance;